import { app } from '../../../../bootstrap/core';
import { documentComponent } from './document.component';

app.component('document', documentComponent);
